import { ReactNode } from "react";
import "../styles/modal.css";
import { BasicButton } from "./BasicButton";

interface ModalType {
  children?: ReactNode;
  isOpen: boolean;
  toggle: () => void;
}

export default function Modal(props: ModalType) {
  return (
    <>
      {props.isOpen && (
        <div className="modal-overlay">
          <div onClick={(e) => e.stopPropagation()} className="modal-box">
            {props.children}
            <BasicButton clickAction={props.toggle} text="CLOSE" />
          </div>
        </div>
      )}
    </>
  );
}
